﻿import $ from 'jquery';
import _ from 'underscore';

export interface IShowIfOptions {
  condition: boolean;
}

export class ShowIf {
  public static wireupDocument: Function = _.once(() => {
    $(document).on('onshowif.rustig', function (e: JQueryEventObject, eventData?: IShowIfOptions) {
      if (eventData === undefined) return;

      $(e.target).toggleShow(eventData.condition);
    });
  });
}